import React, { useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Context } from "../../../../../../Store/index.js";
import callAPI from "../../../../../../api/apiCaller.js";
import Icon from "../../../../../../common/Icon";
import Loading from "../../../../../../common/Loading/index.js";
import {
  AggregateChartsBox,
  AggregateChartsBoxInner,
  AggregateChartsContainer,
  AggregateChartsContainerHeader,
  AggregateChartsTitle,
  ApplicationModalButton,
  ApplicationModalFooterContainer,
  CloseButton,
  EmailBox,
  EmailBoxInner,
  EmailContainer,
  EmailContainerHeader,
  EmailContainerTitle,
  LoaderOuter,
  ModalCloseHeader,
  ModalContainer,
  ModalFooter,
  ModalHeader,
  ModalLoaderContainer,
  ModalOverlay,
  ModalTitle,
  BackButton,
  ButtonText,
  ModalContent,
} from "./styles.js";
import PieChartComponent from "./charts/PieChartComponent.js";
import BarChartComponent from "./charts/BarChartComponent.js";
import { ExportCSV } from "../../../../../../common/utils.js";
import Modal from "../../../../../../common/Modal/index.js";

const AggregatorModal = ({ title, joinAs, setModal }) => {
  // console.log(title, joinAs);

  const { dispatch } = React.useContext(Context);
  const params = useParams();
  const [loading, setLoading] = React.useState(false);
  const [aggregateData, setAggregateData] = React.useState([]);

  const programInformation = () => {
    setLoading(true);
    callAPI(dispatch, "getProgramApplicationAggregates", {
      programId: params.selectedProgram,
      joinAs: joinAs,
    })
      .then((data) => {
        // setAggregateData(data?.data || []);
        const responseData = data?.data || [];
        // const responseData = data?.data?.reduce(
        //   (acc, question) => {
        //     if (question.multipleQuestion) {
        //       acc.multiple.push(question);
        //     } else {
        //       acc.nonMultiple.push(question);
        //     }
        //     return acc;
        //   },
        //   { multiple: [], nonMultiple: [] }
        // );

        // // Sort non-multiple by question text ascending
        // sortedQuestions.nonMultiple.sort((a, b) =>
        //   a.question.localeCompare(b.question)
        // );

        // // Combine: sorted non-multiple first, original-order multiple last
        // const finalSorted = [
        //   ...sortedQuestions.multiple,
        //   ...sortedQuestions.nonMultiple,
        // ];

        // console.log("Final Sorted:", finalSorted);

        // setAggregateData(finalSorted);
        setAggregateData(responseData);
      })
      .finally(() => setLoading(false));
  };

  React.useEffect(() => {
    programInformation();
  }, []);

  const exportDataHandler = () => {
    const labels = [];
    const dataKeys = [];
    const rows = [];

    const questionMap =
      aggregateData?.map((question, index) => ({
        key: `q${index}`,
        text: question.question,
        question,
      })) || [];

    // Set headers
    questionMap.forEach(({ key, text }) => {
      dataKeys.push(key);
      labels.push(text);
    });

    // Determine the max number of answers per free response question
    const maxRows = Math.max(
      ...questionMap.map(({ question }) => question.answers?.length || 1)
    );

    for (let i = 0; i < maxRows; i++) {
      const row = {};

      questionMap.forEach(({ key, question }) => {
        if (question.multipleQuestion) {
          // Only insert aggregate once, in the first row
          if (i === 0) {
            const parts = Object.entries(question.aggregate || {}).map(
              ([k, v]) => (k === "Count" ? `${v}` : `${k}: ${v}`)
            );
            row[key] = parts.join(", ");
          }
        } else {
          // Free responses – 1 answer per row
          const ans = question.answers?.[i];
          if (ans) {
            row[key] = ans.answer;
          }
        }
      });

      rows.push(row);
    }

    // const escapeCSVValue = (value) => {
    //   if (
    //     typeof value === "string" &&
    //     (value.includes(",") || value.includes("\n") || value.includes('"'))
    //   ) {
    //     return `"${value.replace(/"/g, '""')}"`; // Escape inner double quotes
    //   }
    //   return value;
    // };

    // const finalLabels = [...labels].map(escapeCSVValue);

    ExportCSV({
      labels,
      // labels: finalLabels,
      dataKeys,
      tableData: rows,
      fileName: `${title} Responses`,
    });
  };

  const closeHandler = () => {
    console.log("Called");

    setModal(false);
  };

  const modalRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setModal(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setModal]);

  //

  return (
    <ModalOverlay>
      <ModalContainer width="727px" ref={modalRef}>
        {/* Modal Header */}
        <ModalHeader>
          <ModalTitle>
            {`${title} Aggregate Responses (Active Users)`}
          </ModalTitle>
          <ModalCloseHeader>
            <CloseButton
              onClick={() => {
                setModal(false);
              }}
            >
              <Icon type="close" />
            </CloseButton>
          </ModalCloseHeader>
        </ModalHeader>
        <ModalContent>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginBottom: "16px",
              paddingRight: "25px",
            }}
          >
            <BackButton style={{ padding: "6px" }} onClick={exportDataHandler}>
              <Icon type="export-2" />
              <ButtonText>Export</ButtonText>
            </BackButton>
          </div>

          {/* Loader */}
          {loading ? (
            <ModalLoaderContainer>
              <Loading />
            </ModalLoaderContainer>
          ) : (
            <>
              {/* Charts List  */}
              {aggregateData ? (
                aggregateData?.map((question, i) => {
                  return (
                    <>
                      {question?.multipleQuestion === null ? (
                        <AggregateChartsContainer isFreeResponse={true}>
                          <AggregateChartsContainerHeader>
                            <AggregateChartsTitle>
                              {question?.question}
                            </AggregateChartsTitle>
                          </AggregateChartsContainerHeader>

                          <ul>
                            {question?.answers?.map((answer, index) => {
                              return (
                                <li key={index}>
                                  <AggregateChartsTitle>
                                    {answer?.answer}
                                  </AggregateChartsTitle>
                                </li>
                              );
                            })}
                          </ul>
                        </AggregateChartsContainer>
                      ) : (
                        <AggregateChartsContainer>
                          <AggregateChartsContainerHeader>
                            <AggregateChartsTitle>
                              {question?.question}
                            </AggregateChartsTitle>
                          </AggregateChartsContainerHeader>
                          <AggregateChartsBoxInner>
                            <AggregateChartsBox>
                              {i % 2 === 0 ? (
                                <PieChartComponent {...{ question }} />
                              ) : (
                                <BarChartComponent {...{ question }} />
                              )}
                            </AggregateChartsBox>
                          </AggregateChartsBoxInner>
                        </AggregateChartsContainer>
                      )}
                    </>
                  );
                })
              ) : (
                <LoaderOuter>
                  <Loading />
                </LoaderOuter>
              )}
            </>
          )}
        </ModalContent>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default AggregatorModal;
